import flag_de from './svg/flag_de.svg';
import flag_en from './svg/flag_en.svg';
import flag_fr from './svg/flag_fr.svg';
import flag_it from './svg/flag_it.svg';

const svgs = {
  flag_de,
  flag_en,
  flag_fr,
  flag_it,
};

export type SvgFlagsList = keyof typeof svgs;
export default svgs;
